import AxiosClient from "../AxiosClient";

// 仕入取得API
export const postSearchSupply = (params) => {
  return AxiosClient.post("/api/supply/searchSupply", params);

}

// 仕入取得(初期)API
export const postSearchInitialSupply = (params) => {
  return AxiosClient.post("/api/supply/searchInitialSupply", params);
}

// 発注区分取得API
export const postSearchSupplyDivisions = (params) => {
  return AxiosClient.post("/api/supply/searchSupplyDivisions", params);
}

// 仕入先から発注取得API
export const postSearchSupplyBySupplier = (params) => {
  return AxiosClient.post("/api/supply/searchSupplyBySupplier", params);

}

// 仕入取得(印刷)API
export const postSearchSupplyForPrint = (params) => {
  return AxiosClient.post("/api/supply/searchSupplyForPrint", params);
  
}

// 発注確定
export const postUpdateSupply = (params) => {
  return AxiosClient.post("/api/supply/updateSupply", params);
  
}


